import InvoiceSystem from "@material-symbols/svg-500/rounded/request_quote.svg?react";
import { memo } from "react";

import type { SVGIconProps } from "@/components/ui/icon/_utils/icon-creator";
import { IconCreator } from "@/components/ui/icon/_utils/icon-creator";

const InvoiceSystemIcon = (props: SVGIconProps) => {
	const Icon = () => IconCreator({ ...props, svgIcon: InvoiceSystem });
	return <Icon />;
};

export default memo(InvoiceSystemIcon);
